import HeaderBox from "../../generic/arpariBoxes/headerBox";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { qaConfig } from "./config.js";
import OuterBox from "../../generic/arpariBoxes/OuterBox.js";

function FrequentlyAskedQuestions() {
    return (
        <OuterBox>
            <HeaderBox
                title="Frequently Asked Question" />

            {qaConfig.map((sectionData, sectionIndex) => (
                <Box key={sectionIndex} sx={{ mb: 2 }}>
                    <Paper elevation={3} sx={{ p: 2 }}>
                        <Typography variant="h5" sx={{ mb: 2 }}>
                            {sectionData.section}
                        </Typography>

                        {sectionData.qa.map((item, idx) => (
                            <Accordion key={idx}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>{item.question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>{item.answer}</AccordionDetails>
                            </Accordion>
                        ))}
                    </Paper>

                    {sectionIndex < qaConfig.length - 1 && (
                        <Divider sx={{ marginTop: 3, marginBottom: 2 }} />
                    )}
                </Box>
            ))}
        </OuterBox >
    )
}

export default FrequentlyAskedQuestions;